import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import CurrencyRates from './currency-rates';
import CurrencyRatesDetail from './currency-rates-detail';
import CurrencyRatesUpdate from './currency-rates-update';
import CurrencyRatesDeleteDialog from './currency-rates-delete-dialog';
import PrivateRoute from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute exact path={`${match.url}/new`} component={CurrencyRatesUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id/edit`} component={CurrencyRatesUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={CurrencyRatesDetail} />
      <ErrorBoundaryRoute path={match.url} component={CurrencyRates} />
    </Switch>
    <PrivateRoute exact path={`${match.url}/:id/delete`} component={CurrencyRatesDeleteDialog} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
  </>
);

export default Routes;
